import React                     from 'react';
import numeral                   from 'numeral';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';


const PartOption = (props) => {
  return(
    <React.Fragment>
      <td 
       className={`vendor ${(props.quantity == props.selected_quantity) ? "activate" : ""}`} 
       data-num-board={props.quantity}>
        <div className="vendor">{props.vendor}</div>
        <div className="vpn">{props.vpn}</div>
      </td>
      <td 
       className={`stock ${(props.quantity == props.selected_quantity) ? "activate" : ""}`} 
       data-num-board={props.quantity} >
        {props.stock}
      </td>
      <td 
       className={`required-qty ${(props.quantity == props.selected_quantity) ? "activate" : ""}`} 
       data-num-board={props.quantity} >
        {props.required_qty}
      </td>
      <td 
       className={`price ${(props.quantity == props.selected_quantity) ? "activate" : ""}`} 
       data-num-board={props.quantity} data-price={props.price} >
        ${numeral(props.price).format('0.00')}
      </td>
    </React.Fragment>
  )
} 

export default PartOption;